const routes = [
  // ADMIN
  {
    path: "/",
    name: "Golpino Admin Login Page",
    component: () => import("../components/Admin/Login/Login.vue"),
  },
  {
    path: "/admin",
    name: "Golpino Admin Page",
    component: () => import("../components/Admin/AddStuff.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/finances",
    name: "Finances",
    component: () => import("../components/Admin/Finances/Finances.vue"),
  },
  {
    path: "/admin/finances/:id",
    name: "FinancesDetailes",
    component: () =>
      import("../components/Admin/Finances/FinancesDetailes.vue"),
  },
  {
    path: "/admin/add/district",
    name: "Golpino Add Districts Page",
    component: () => import("../components/Admin/Forms/District.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/districts",
    name: "Golpino Display Districts Page",
    component: () => import("../components/Admin/Display/Districts.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/district/:id",
    name: "Golpino Edit District Page",
    component: () => import("../components/Admin/Forms/District.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/categories",
    name: "Golpino Display Categories Page",
    component: () => import("../components/Admin/Display/Categories.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/qwertyzxcvb/admin/add/category",
    name: "Golpino Add Categories Page",
    component: () => import("../components/Admin/Forms/Category.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/category/:id",
    name: "Golpino Edit Category Page",
    component: () => import("../components/Admin/Forms/Category.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/tags",
    name: "Golpino Display Tags Page",
    component: () => import("../components/Admin/Display/Tags.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/tag",
    name: "Golpino Add Tags Page",
    component: () => import("../components/Admin/Forms/Tag.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/tag/:id",
    name: "Golpino Edit Tag Page",
    component: () => import("../components/Admin/Forms/Tag.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/ranges",
    name: "Golpino Display Ranges Page",
    component: () => import("../components/Admin/Display/ServiceRanges.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/range",
    name: "Golpino Add Ranges Page",
    component: () => import("../components/Admin/Forms/ServiceRange.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/range/:id",
    name: "Golpino Edit Range Page",
    component: () => import("../components/Admin/Forms/ServiceRange.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/distances",
    name: "Golpino Display Distances Page",
    component: () => import("../components/Admin/Display/Distances.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/distance",
    name: "Golpino Add Distances Page",
    component: () => import("../components/Admin/Forms/Distance.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/distance/:id",
    name: "Golpino Edit Distance Page",
    component: () => import("../components/Admin/Forms/Distance.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/attributes",
    name: "Golpino Display Attributes Page",
    component: () => import("../components/Admin/Display/Attributes.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/attribute",
    name: "Golpino Add Attributes Page",
    component: () => import("../components/Admin/Forms/Attribute.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/attribute/:id",
    name: "Golpino Edit Attribute Page",
    component: () => import("../components/Admin/Forms/Attribute.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/orders",
    name: "Golpino Admin Orders Page",
    component: () => import("../components/Admin/Order/Summary.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/orders/:id",
    name: "Golpino Admin Order Page",
    component: () => import("../components/Admin/Order/AnOrder.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/verify-shop",
    name: "Golpino Admin Order Page",
    component: () => import("../components/Admin/Verify/VerifySeller.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/discounts",
    name: "Golpino Display Discounts Page",
    component: () => import("../components/Admin/Display/Discounts.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  // {
  //   path: "/maps",
  //   name: "maps",
  //   component: () => import("../components/Admin/Display/Discounts.vue"),
  //   meta: {
  //     requiresAdmin: true,
  //   },
  // },
  {
    path: "/admin/add/discount",
    name: "Golpino Add Discount Page",
    component: () => import("../components/Admin/Forms/Discount.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/discount/:id",
    name: "Golpino Edit Discount Page",
    component: () => import("../components/Admin/Forms/Discount.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/verify-shops",
    name: "Golpino Verify Shops Page",
    component: () => import("../components/Admin/Display/Shops.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/shops",
    name: "Golpino Admin Shops Info Page",
    component: () => import("../components/Admin/Shops/ShopList.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/shops/:id",
    name: "Golpino Admin Shop Info Page",
    component: () => import("../components/Admin/Shops/AShop.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/view/subjects",
    name: "Golpino Complaint Subjects Page",
    component: () => import("../components/Admin/Display/Subjects.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/map",
    name: "map",
    component: () => import("../components/Admin/map/MapVisual2.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/edit/subject/:id",
    name: "Golpino Edit Subject Page",
    component: () => import("../components/Admin/Forms/Subject.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/complaints",
    name: "Golpino Admin Contacts Page",
    component: () => import("../components/Admin/Display/ContactUs.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/comments",
    name: "Golpino Admin Comments Page",
    component: () => import("../components/Admin/Comments/Comments.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/comment/:id",
    name: "Golpino Admin Comment Page",
    component: () =>
      import("../components/Admin/Comments/partials/Comment.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/users",
    name: "Golpino Admin Users Page",
    component: () => import("../components/Admin/Users/Users.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/delivery-time",
    name: "Golpino Admin Delivery Times Page",
    component: () => import("../components/Admin/Display/DeliveryTime.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/delivery-time",
    name: "Golpino Add Delivery Time Page",
    component: () => import("../components/Admin/Forms/DeliveryTime.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/add/delivery-time/:id",
    name: "Golpino Edit Delivery Time Page",
    component: () => import("../components/Admin/Forms/DeliveryTime.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/banner",
    name: "Golpino Admin Banner Page",
    component: () => import("../components/Admin/Forms/Banners.vue"),
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/commission",
    name: "Golpino Admin commission",
    component: () => import("../components/Admin/Forms/commission"),
    meta: {
      requiresAdmin: true,
    },
  },
];

export default routes;
